import React from "react";
import "./ToolTips.scss";
import {
  UniqueID,
  CheckValue,
  CheckWidth,
} from "../../../services/CommonFunction";

class ToolTips extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      displayTooltip: false,
      random: UniqueID(),
      element: null,
      overflow: true,
    };

    this.hideTooltip = this.hideTooltip.bind(this);
    this.showTooltip = this.showTooltip.bind(this);
  }

  componentDidMount() {
    this.setEventListner("addEventListener");
    if (CheckValue(this.props.overflow) && this.props.overflow) {
      const { width } = this.ele.parentElement.getBoundingClientRect();
      const textWidth = CheckWidth(this.child.textContent, 0);
      this.setState({ overflow: textWidth > width });
    }
  }

  setEventListner = (status) => {
    this.child[status]("mouseleave", this.hideTooltip);
    this.child[status]("mouseover", this.showTooltip);
  };

  get child() {
    // const ele = document.getElementById(this.state.random);
    const child =
      this.ele.firstChild instanceof HTMLElement
        ? this.ele.firstChild
        : this.ele;
    return child;
  }

  get ele() {
    return document.getElementById(this.state.random);
  }

  checkWidth = (text) => {
    console.info(text, CheckWidth(text, 0));
  };

  componentWillUnmount() {
    this.hideTooltip();
    this.setEventListner("removeEventListener");
  }
  hideTooltip() {
    if (this.props.showTooltip) {
      if (CheckValue(this.state.element)) {
        document.body.removeChild(this.state.element);
      }
      this.setState({ displayTooltip: false, element: null });
    }
  }

  showTooltip() {
    if (
      !this.state.displayTooltip &&
      this.props.showTooltip &&
      this.state.overflow
    ) {
      // let position = this.props.position || 'left';
      let rect = this.child.getBoundingClientRect();
      this.toolTip(this.props.position || "left", rect);
    }
  }

  toolTip = (position, rect) => {
    // if(window.innerWidth - rect.x < 250) {
    //   this.toolTip('left',rect);
    //   return;
    // } else if(rect.x < 250) {
    //   this.toolTip('right',rect);
    //   return;
    // }

    const div = document.createElement("div");
    div.className = `tooltips-bubble tooltips-${position}`;
    div.style.opacity = "0";
    div.style.zIndex = "-10";
    document.body.appendChild(div);

    const div1 = document.createElement("div");
    div1.className = `tooltip-message`;
    div1.innerHTML = `${this.props.message}`;
    div.appendChild(div1);

    if (this.props.title) {
      const span = document.createElement("span");
      span.innerText = this.props.title;
      span.className = "tooltip_message_span";
      div1.prepend(span);
    }

    let top = rect.top + window.scrollY;
    let left = rect.left + window.scrollX;

    const divRect = div.getBoundingClientRect();

    setTimeout(() => {
      if (position === "top") {
        const temp = div.getBoundingClientRect();
        const tempTop = top - (temp.height - divRect.height);
        div.style.top = tempTop + "px";
      }
      div.style.opacity = "1";
      div.style.zIndex = "9999";
    }, 1);
    if (position === "right") {
      top += rect.height / 2;
      left += rect.width;
    } else if (position === "top") {
      top -= divRect.height;
      left += rect.width / 2;
    } else if (position === "bottom") {
      top += rect.height;
      left += rect.width / 2;
    } else {
      top += rect.height / 2;
      left -= divRect.width;
    }

    div.style.left = left + "px";
    div.style.top = top + "px";

    this.setState({ displayTooltip: true, element: div });
  };

  render() {
    // let message = this.props.message;
    // let position = this.props.position || 'left';
    return (
      // <span className='tooltips' onMouseLeave={this.hideTooltip}>
      // <span className='tooltip-trigger' id={this.state.random} onMouseOver={event => show?this.showTooltip(event):null}>
      <span
        className={`tooltip-trigger ${this.props.className || ""}`}
        id={this.state.random}
      >
        {this.props.children}
      </span>
      // </span>
    );
  }
}

export default ToolTips;
